"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get CompetencyImportPhase () {
        return CompetencyImportPhase;
    },
    get CompetencyImportProgress () {
        return CompetencyImportProgress;
    },
    get CompetencyImportResult () {
        return CompetencyImportResult;
    },
    get StartCompetencyImportResponse () {
        return StartCompetencyImportResponse;
    }
});
const _zod = require("zod");
const _response = require("./response");
const CompetencyImportPhase = _zod.z.enum([
    "analyzing",
    "extracting",
    "parsing"
]);
const CompetencyImportProgress = _zod.z.object({
    phase: CompetencyImportPhase,
    message: _zod.z.string(),
    sectionsCompleted: _zod.z.number().int().optional(),
    sectionsTotal: _zod.z.number().int().optional()
});
const CompetencyImportResult = _zod.z.object({
    suggestions: _zod.z.array(_response.AskSSECompetencySuggestion),
    summary: _zod.z.string(),
    pageCount: _zod.z.number().int()
});
const StartCompetencyImportResponse = _zod.z.object({
    taskId: _zod.z.string()
});
